import React from 'react'
import './IndustryServed.css'

const IndustryServed = ({ transporter_data }) => {
    const industryServed = transporter_data?.industry_served ?? []

    const items = industryServed.map((item, i) => (
        <div className="industriesservedcontent" key={i}>
            <b>{item.name || ''}</b>
            {item.percentage ? `: ${item.percentage}%` : ''}
        </div>
    ))

    return (
        <div className="industriesservedcard">
            <div className="industriesservedcontainer row">
                <div className="col-12">
                    <span className="data_header">Industries Served</span>
                </div>
                <div className="col-12">
                    {items.length === 0 ? 'Details not available' : items}
                </div>
            </div>
        </div>
    )
}

export default IndustryServed
